export default function isLocal() {
    return process.env.NODE_ENV !== "production";
}
